const Report = () =>
  import(/* webpackChunkName: "branch" */ '@/pages/branch/index.vue')
const Create = () =>
  import(/* webpackChunkName: "branch" */ '@/pages/branch/create.vue')
const Edit = () =>
  import(/* webpackChunkName: "branch" */ '@/pages/branch/edit.vue')

export default {
  path: 'branches',
  meta: {
    label: 'branch',
    auth: 'branch'
  },
  component: {
    name: 'branch',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BranchReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'CreateBranch',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'EditBranch',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
